<template>
  <div class="login-page overflow-x-hide overflow-y-hide">
    <div class="container no-padding">
      <div class="row no-margin tw-relative">
        <div class="col-md-12" :style="{ 'min-height': dyn_height }">
          <HeaderLogo :page-type="'3'" :light_logo="true" />

          <div
            class="row no-padding main-body h-100"
            :style="{ height: windowHeight }"
          >
            <div class="col-md-12 flex-container">
              <BrandPattern page="LOGIN" :top="72" />
            </div>
          </div>
        </div>

        <errorhandler
          v-if="showProspectCallbackError || null"
          :prospect-callback-error-msg="prospectCallbackErrorMsg"
          @reset-show-prospect-callback-error="resetShowProspectCallbackError"
        />

        <!-- Sign In Modal -->
        <div
          id="loginModal"
          ref="loginModal"
          class="modal fade login-modal show tw-block"
          role="dialog"
          aria-labelledby="loginModalLabel"
          data-backdrop="false"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="modal-body-sec1">
                  {{ getUiText("app-user-login-heading-1") }}
                </div>
                <div class="form-group">
                  <label for="id" class="control-label input-label-form">{{
                    getUiText("app-user-login-username-heading-1")
                  }}</label>
                  <input
                    id="username"
                    ref="username"
                    v-model="loginData.username"
                    data-cy="usr"
                    type="username"
                    :class="!emailValid ? 'invalid-input' : ''"
                    tabindex="0"
                    class="form-control form-control-lg password-input username-input"
                    :placeholder="userPlaceholder"
                    @blur="inputBlur('EMAIL', true)"
                    @input="
                      (e) => {
                        loginErrorMsg = '';
                        inputBlur('EMAIL', false, e.target?.value || '');
                      }
                    "
                  />
                  <div
                    class="error-msg"
                    :class="!emailValid ? 'mg-top-19' : ''"
                    :v-if="!emailValid || null"
                  >
                    <span>{{ emailValidationMsg }}</span>
                  </div>

                  <label for="id" class="control-label input-label-form">{{
                    getUiText("app-user-login-password-heading-1")
                  }}</label>
                  <div class="password-sec">
                    <input
                      id="psw"
                      ref="password"
                      v-model="loginData.password"
                      data-cy="psw"
                      :type="passwordFieldType"
                      class="form-control form-control-lg password-input"
                      @keyup.enter="submit"
                      @input="keyMonitor"
                    />
                    <span
                      tabindex="0"
                      class="show-password pr-3"
                      @click="togglePassword"
                    >
                      <img
                        v-if="!enable_showpassword || null"
                        class="tw-h-[40px]"
                        src="@/assets/img/eye-view.svg"
                      />
                      <img
                        v-else-if="enable_showpassword && !showPassword"
                        class="tw-h-[40px]"
                        src="@/assets/img/view-streamline.svg"
                      />
                      <img
                        v-else-if="enable_showpassword && showPassword"
                        class="tw-h-[40px] tw-mb-[2px]"
                        src="@/assets/img/view-off-streamline.svg"
                      />
                      <span
                        id="show-psw"
                        class="show-password-label"
                        :class="enable_showpassword ? 'enabled' : 'disabled'"
                        >{{
                          !showPassword
                            ? getUiText("app-user-login-password-show-1")
                            : getUiText("app-user-login-password-hide-1")
                        }}</span
                      >
                    </span>
                  </div>
                  <div
                    id="error-msg"
                    class="error-msg"
                    data-cy="signin-error"
                    :class="loginErrorMsg ? 'mg-top-25' : ''"
                    :v-if="loginErrorMsg !== '' || null"
                  >
                    <span>{{ loginErrorMsg }}</span>
                  </div>
                </div>
                <div class="login-btn">
                  <button
                    id="signin-button"
                    data-cy="signin-button"
                    type="button"
                    :class="`btn btn-primary signin-button ${
                      passwordIV === ''
                        ? 'tw-cursor-not-allowed tw-pointer-events-none'
                        : ''
                    }`"
                    :disabled="disableButton"
                    @click="submit"
                  >
                    {{ getUiText("app-user-login-button-signin-1") }}
                  </button>
                  <a
                    class="forgot-text-button"
                    data-cy="login-page-forgot-password-button"
                    tabindex="0"
                    @click="forgotPassword"
                    >{{
                      getUiText("app-user-login-password-forgotten-link-1")
                    }}</a
                  >
                </div>
              </div>
              <div class="modal-footer">
                <div class="modal-sec6">
                  <div class="modal-sec6-sec1">
                    <VRuntimeTemplate :template="footerText" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import $ from "jquery";
import userService from "@/services/user/userService";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils, { passwordHash } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import VRuntimeTemplate from "vue3-runtime-template";
import store from "@/store";
import { UserRoute } from "@/services/apiRoutes/routes";
import {
  localStorageBoolean,
  localStorageKey,
  MFAStatus,
} from "@/utils/constants";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import router from "@/router";
import HeaderLogo from "@/components/common/headerLogoWithoutLangPicker.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern.vue";
import {
  startRegistration,
  startAuthentication,
} from "@simplewebauthn/browser";
import { useRoute } from "vue-router";

let dyn_height = ref("");
const disableButton = ref(true);
let windowHeight = ref("");
let showPassword = ref(false);
let enable_showpassword = ref(false);
const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");
const loginData = ref({ username: "", password: "" });
let loginErrorMsg = ref("");
const emailFieldFocus = ref(0);

let userPlaceholder = ref("");
const footerTextTags: any = {
  "app-nav-cyber-system-text": { openTag: "<strong>", closeTag: "</strong>" },
  "app-user-login-help-link-1": {
    openTag: '<a href="javascript:void(0)">',
    closeTag: "</a>",
  },
};

let footerText = ref("");
const loginModal = ref<null>(null);
const passwordFieldType = ref("password");

const languageSelected = computed(
  () => store.state.LanguagePicker.languageSelected,
);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const passwordIV = computed(() => store.state.LanguagePicker.pwdFeIv);

const checkFormVals = () => {
  if (
    loginData.value.username === "" ||
    loginData.value.password === "" ||
    emailValid.value === false
  ) {
    disableButton.value = true;
  } else {
    disableButton.value = false;
  }
};

const getUiText = (id: string, isArray = false) => {
  return Utils.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const getProcessedUIText = (id: string, tags: any) => {
  return Utils.getProcessedUIText(
    id,
    tags,
    languageSelectedText.value,
    defaultUiText.value,
  );
};

const updateUIVariables = () => {
  userPlaceholder.value = getUiText("app-user-login-username-prompt-1");
  footerText.value =
    "<span>" +
    getProcessedUIText("app-user-login-help-text-1", footerTextTags) +
    "</span>";
};

const username: any = ref();
const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
  username.value && username.value.focus();
};

const password = ref();
const togglePassword = () => {
  if (!enable_showpassword.value) return;
  showPassword.value = !showPassword.value;

  passwordFieldType.value =
    password.value.type === "password" ? "text" : "password";
};
const emailValid = ref(true);
const emailValidationMsg = ref("");
const inputBlur = (inputIs: string, isBlur = false, val) => {
  if (isBlur) {
    emailFieldFocus.value++;
  }
  if (inputIs === "EMAIL" && emailFieldFocus.value > 0) {
    if (!Utils.IsEmailValid(isBlur ? loginData.value.username : val)) {
      emailValid.value = false;
      emailValidationMsg.value = getUiText("app-prospect-error-invalid-email");
    } else {
      emailValid.value = true;
      emailValidationMsg.value = "";
    }
  }
  checkFormVals();
};

const setLanguages = async () => {
  await Utils.getV3Recaptcha().then(
    async (finalKey: any) => {
      localStorage.removeItem("csrfReloadDone");
      const recaptcha = await load(`${finalKey}`, {
        autoHideBadge: true,
      });
      recaptcha.execute("submit").then((token) => {
        localStorage.setItem(localStorageKey.recaptcha, token);
        store.dispatch("LanguagePicker/setLanguages", token);
      });
      recaptcha.execute("submit").then((token) => {
        localStorage.setItem(localStorageKey.recaptcha, token);
        store.dispatch("LanguagePicker/setLanguageList", token);
      });
    },
    (error: any) => {
      if (error && error.data && error.data.error && error.data.error.type) {
        if (error.data.error.type === "exc_session_invalid-1") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data.error),
          );
          router.push({ path: "/" });
        } else {
          showErrorInfo(error.data.error);
        }
      } else if (error.data.message === "invalid csrf token") {
        if (localStorage.getItem("csrfReloadDone") == null) {
          localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
          router.go(0);
        }
        sessionStorage.setItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(error.data),
        );
        router.push({ path: "/" });
      } else {
        showErrorInfo(error.data);
      }
    },
  );
};

const keyMonitor = () => {
  loginErrorMsg.value = "";
  const myInput: any = document.getElementById("psw");
  enable_showpassword.value = myInput.value.length > 0 ? true : false;
};

const showErrorInfo = (errorInfo: any) => {
  if (errorInfo && errorInfo !== "") {
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const resetShowProspectCallbackError = () => {
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
};

const forgotPassword = () => {
  router.push(UserRoute.forgotPassword);
};

const submit = async () => {
  if (!enable_showpassword.value) return;

  const passwordValue = await passwordHash(
    loginData.value.password,
    passwordIV.value,
  );

  const formData = {
    email: loginData.value.username,
    password: `%s${passwordIV.value}.${passwordValue}`,
  };

  userService.login(formData).then(
    async (res: any) => {
      localStorage.removeItem("csrfReloadDone");
      localStorage.removeItem(localStorageKey.currentOrgData);
      localStorage.removeItem(localStorageKey.currentUserData);
      if (window.innerWidth > 768) {
        store.dispatch("Navigation/setMenuOpen");
        store.dispatch("Navigation/setChevronActive", true);
      }
      if (res.data.data.mfaStatus === MFAStatus.NOT_REQUIRED) {
        await Utils.afterLoginActions(res.data.data);
      } else if (res.data.data.mfaStatus === MFAStatus.REGISTERED) {
        store.dispatch("User/setPreSession");
        router.push(UserRoute.twoStepAuthentication);
      } else if (res.data.data.mfaStatus === MFAStatus.NOT_REGISTERED) {
        router.push(UserRoute.mfaSelection);
      } else if (
        res.data.data.mfaStatus === MFAStatus.REGISTERED_PK ||
        res.data.data.mfaStatus === MFAStatus.REGISTERED_PKONLY
      ) {
        const isTotpRegistered =
          res.data.data.mfaStatus === MFAStatus.REGISTERED_PK ? true : false;
        webAuthnVerify(isTotpRegistered);
      }
    },
    (error: any) => {
      if (error && error.data && error.data.error && error.data.error.type) {
        if (error.data.error.type === "exc_session_invalid-1") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data.error),
          );
          router.push({ path: "/" });
        } else if (error.data.error.type === "exc_auth_perm-2") {
          loginErrorMsg.value = getUiText("app-login-credentials-error-1");
        } else {
          if (error.data.error.id === "email") {
            emailValid.value = false;
            emailValidationMsg.value = getUiText(
              "app-prospect-error-invalid-email",
            );
            disableButton.value = true;
          } else {
            loginErrorMsg.value =
              error.data?.error?.message ||
              getUiText("app-login-credentials-error-1");
          }
        }
      } else {
        if (
          error &&
          error.data &&
          error.data.message &&
          error.data.message === "invalid csrf token"
        ) {
          if (localStorage.getItem("csrfReloadDone") == null) {
            let temp = { message: "Please try again" };
            localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
            showErrorInfo(temp);
            router.go(0);
          }
        }
        showErrorInfo(error.data);
      }
    },
  );
};

const webAuthnVerify = (isTotpRegistered = false) => {
  userService
    .mfaWebauthnAuthenticate()
    .then(async (res: any) => {
      try {
        const challengeResponse = res.data.data;
        const attResp = await startAuthentication(challengeResponse);
        userService
          .mfaWebauthnVerifyAuthentication(attResp)
          .then(async (res: any) => {
            if (res && res.status && res.status === 200 && res.data) {
              await Utils.afterLoginActions(res.data.data);
            }
          });
      } catch (err) {
        store.dispatch("User/setPreSession");
        if (isTotpRegistered) router.push(UserRoute.twoStepAuthentication);
      }
    })
    .catch((err: any) => {
      if (isTotpRegistered) {
        store.dispatch("User/setPreSession");
        router.push(UserRoute.twoStepAuthentication);
      }
    });
};

onBeforeUnmount(() => {
  const body = $("body");
  if (body.hasClass("page-opacity")) {
    body.removeClass("page-opacity page-bg page-shadow");
  }
});
const route = useRoute();
onMounted(() => {
  const email = route.query.email;
  if (email) {
    loginData.value.username = email as string;
  }
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });
  // (loginModal as any).modal("show");
  document.getElementById("loginModal")?.classList.add("show");
  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg");
  }
  setLanguages();
  updateUIVariables();
});

watch(
  () => loginData.value.username,
  () => {
    checkFormVals();
  },
  { deep: true },
);

watch(
  () => loginData.value.password,
  () => {
    checkFormVals();
  },
  { deep: true },
);

watch(
  () => languageSelected,
  () => {
    updateUIVariables();
  },
  { deep: true },
);

defineExpose({ submit });
</script>

<style lang="scss" scoped>
.login-page {
  background: #0345bd;

  .modal {
    pointer-events: none;
  }
  .login-modal {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 50%;
    pointer-events: none;
    top: 50%;
    transform: translate(-50%, -50%);
    .form-control:focus {
      box-shadow: none;
    }
    .form-control::placeholder {
      color: #b7b7b7;
      font-size: 22px;
    }
    .modal-dialog {
      transition: none;
    }
    .modal-content {
      box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
      border-radius: 6px;
      border: none;
    }
    .show-password {
      align-items: center;
      .show-password-label {
        margin: 0px;
      }
    }
    .modal-footer {
      justify-content: flex-start;
    }
  }
  .forgot-text-button {
    cursor: pointer;
  }
}
</style>
